import Header from "./component/Header";
import DefaultLayoutAdmin from "./component/defaultLayoutAdmin";
import { Client } from "./route/client.route";
import { useLocation } from 'react-router-dom';
import Sidebar from "./component/Sidebar";
import FloatingContact from "./component/FloatingContact";

const roterAdmin = '/admin'
function App() {
  const location = useLocation();
  const currentPath = location.pathname;

  if(currentPath?.includes(roterAdmin)) {
    return <DefaultLayoutAdmin />
  } else {
    return (
      <div className="App bg-[#fafafa] min-h-screen">
        <Header />
        <div className="flex">
          <Sidebar />
          <main className="flex-1">
            <Client />
          </main>
        </div>
        <FloatingContact phone={"+84901234567"} />
      </div>
    );
  }
}

export default App;
